import React, { PropTypes, Component } from 'react';
import RateTemplate from '../../../generic-components/rate-tables/rate-table-template-container';
import AddItemCard from '../../../generic-components/add-item-card/add-item-card';
import DateUtils from '../../../../../utils/date-utils';
import SeasonErrors from '../../../generic-components/season-errors';
import SeasonAboveRates from './season-for-seasonRates';
import HelperLink from '../helper-link';
import moment from 'moment';
import R, { concat, propOr, chain, call, compose, filter, has } from 'ramda';
import { connect } from 'react-redux';


const propTypes = {
  supplierEditable: PropTypes.bool,
  seasonRates: PropTypes.array,
  addRates: PropTypes.func,
  deleteFromProduct: PropTypes.func,
  editSeason: PropTypes.func,
  openAddEditContractDialog: PropTypes.func,
  productType: PropTypes.string,
  overlappedSeasonRates: PropTypes.array,
  notCompletedRatePackages: PropTypes.array,
  existingSeasons: PropTypes.array,
  selectedPackage: PropTypes.string,
  ratePackages: PropTypes.array,
  ratePackageNames: PropTypes.array,
  contractingPeriod: PropTypes.object,
  onRatePackageChange: PropTypes.func,
  openGlobalAlert: PropTypes.func,
};
class LeftThreeRates extends Component {
  constructor() {
    super();
    this.state = { selectedPackage: 'Primary' };
  }

  shouldComponentUpdate(nextProps) {
    const propKeys = R.keys(propTypes).filter(key => propTypes[key] !== PropTypes.func);
    return !R.equals(R.pick(propKeys, this.props), R.pick(propKeys, nextProps))
  }
  render() {
    const {
      seasonRates,
      existingSeasons,
      openAddEditContractDialog,
      productType,
      supplierEditable,
      deleteFromProduct,
      contractingPeriod,
      overlappedSeasonRates,
      openGlobalAlert,
    } = this.props;

    const arrayOfDates = existingSeasons ? existingSeasons.reduce((result, season) => {
      return concat((season.dateRanges || []), result);
    }, []) : [];
    const contractingPeriodCovered = DateUtils.checkIfFullSeasonCoveredForAProduct(contractingPeriod.startDate, contractingPeriod.endDate, arrayOfDates);
    return (
      <div id="seasonRates">
        <HelperLink
          labelStyle={{ marginBottom: '12px' }}
          value="seasons"
          showSync={Boolean(existingSeasons && existingSeasons.length)}
          labelText="SEASONS & RATES"
        />
        {
          existingSeasons && existingSeasons.length ?
            (<div>
              <SeasonErrors
                startDate={contractingPeriod.startDate}
                endDate={contractingPeriod.endDate}
                editable={supplierEditable}
                existingSeasons={existingSeasons}
                openAddEditContractDialog={openAddEditContractDialog}
                seasonDateRanges={call(compose(
                  filter(has('seasonStartDate')),
                  chain(propOr([], 'dateRanges'))
                ), existingSeasons)}
              />
              {
                (seasonRates.length > existingSeasons.length ? seasonRates : existingSeasons).map((season, index) => {
                  const { seasonName, dateRanges } = season;
                  const rateSets = R.pathOr([], [index, 'rateSets'], seasonRates);
                  const dateString = dateRanges && dateRanges.length ? `${moment.utc((dateRanges || [{}])[0].seasonStartDate).format('D MMM YYYY')} - ${moment.utc((dateRanges || [{}])[0].seasonEndDate).format('D MMM YYYY')}` : '';
                  const isNotContractingPeriod = seasonName !== dateString;
                  return (
                    <div key={index} style={{ marginBottom: '24px' }}>
                      <SeasonAboveRates
                        existingSeasons={existingSeasons}
                        isNotContractingPeriod={isNotContractingPeriod}
                        dateRanges={dateRanges}
                        seasonName={seasonName}
                        contractingPeriod={contractingPeriod}
                        seasonRatesIndex={index}
                        deleteFromProduct={deleteFromProduct}
                        openAddEditContractDialog={openAddEditContractDialog}
                        supplierEditable={supplierEditable}
                      />
                      <div
                        style={{ border: !R.isEmpty(overlappedSeasonRates) && R.contains(index, overlappedSeasonRates) ? '1px solid red' : 'none', overflow: 'auto' }}
                      >
                        {
                          !R.isEmpty(overlappedSeasonRates) && R.contains(index, overlappedSeasonRates) && (
                            <div style={{ color: 'red', padding: '8px', whitespace: 'pre-wrap' }}>
                              {productType === 'Accommodation' ? `Rate sets cannot have overlapping min/max night stays and be applied to the same days of the week.

In order to have two types of rates for the same days of the week, please either adjust the min/max night stays (so they aren't overlapping), or use a rate package.`
                                : `Rate sets cannot have overlapping days of the week.

Please either adjust the days of week (so they aren't overlapping), or use a rate package.`}
                            </div>
                          )
                        }
                        {
                          rateSets.map((rateSet, rateSetsIndex) => {
                            return (
                              <div
                                style={{ marginBottom: rateSetsIndex === rateSets.length - 1 ? '' : '16px' }}
                                key={`rateSet${rateSetsIndex}`}
                              >
                                <RateTemplate
                                  productType={productType}
                                  rateSet={rateSet}
                                  showHeader={rateSetsIndex === 0}
                                  supplierEditable={supplierEditable}
                                  onEdit={() => {
                                    openAddEditContractDialog({
                                      type: 'editRates',
                                      data: {
                                        rateSets,
                                        rateSetsIndex,
                                        seasonRatesIndex: index,
                                        seasonName: isNotContractingPeriod ? seasonName : dateString,
                                      },
                                    });
                                  }}
                                  rateSetsIndex={rateSetsIndex}
                                  deleteFromProduct={() => {
                                    openGlobalAlert({
                                      text: 'Are you sure you want to delete this rate set?',
                                      onOk: () => deleteFromProduct({ seasonRatesIndex: index, rateSetsIndex, updateType: 'DELETE_RATE_SET_FROM_SEASON' }),
                                    });
                                  }}
                                />
                              </div>);
                          })
                        }
                      </div>
                      {
                        supplierEditable && (['Not Operating', 'Dynamic Rates'].indexOf(seasonName) < 0) ? (
                          <div
                            style={{ marginTop: '8px', color: rateSets && rateSets.length ? '#00bcd4' : '#f44336', cursor: 'pointer' }}
                            onClick={() => {
                              openAddEditContractDialog({
                                type: 'editRates',
                                data: {
                                  rateSets: R.append({ new: true }, rateSets),
                                  rateSetsIndex: rateSets.length,
                                  seasonRatesIndex: index,
                                  seasonName: isNotContractingPeriod ? seasonName : dateString,
                                },
                              });
                            }}
                          >
                            {`+ Add${rateSets && rateSets.length ? ' another' : ''} rate set to ${seasonName}`}
                          </div>
                        ) : undefined
                      }
                    </div>
                  );
                })
              }
              { contractingPeriodCovered > 0 ? <AddItemCard text="Add rates to a new season" onClick={() => openAddEditContractDialog({ type: 'addRates', title: 'Add Rate Set' })} editable={supplierEditable} hide={!supplierEditable} /> : undefined }
            </div>) :
            <div>
              <AddItemCard text="Add rates" onClick={() => openAddEditContractDialog({ type: 'addRates', title: 'Add Rate Set' })} editable={supplierEditable} />
            </div>
        }
      </div>
    );
  }
}

LeftThreeRates.propTypes = propTypes;

const mapStateToProps = ({ contracting }) => {
  const leftNav = contracting.contractActivitiesProducts.get('leftNav').toJS();
  const rightContent = contracting.contractActivitiesProducts.get('rightSideContent').toJS();
  const draftErrors = contracting.contractActivitiesProducts.get('draftErrors').toJS();
  const productId = rightContent.productId;
  const overlappedSeasonRates = leftNav.contractState !== 'draft' ? [] : R.call(R.compose(
    R.pathOr([], ['rates', 'overlappedSeasonRates']),
    R.find(prod => prod.productId === productId && (rightContent.ratePackageName || '') === (prod.ratePackageName || ''))
  ), draftErrors.products || []);
  return ({
    seasonRates: rightContent.seasonRates || [],
    supplierEditable: leftNav.supplierEditable,
    contractState: leftNav.contractState,
    productName: leftNav.productName,
    overlappedSeasonRates,
    contractingPeriod: { startDate: leftNav.startDate, endDate: leftNav.endDate },
    existingSeasons: rightContent.seasons || [],
  });
};

const mapActions = ({
  openGlobalAlert: payload => ({
    type: 'open_global_alert',
    payload,
  }),
});
export default connect(mapStateToProps, mapActions)(LeftThreeRates);



// WEBPACK FOOTER //
// ./src/app/components/contracting/contract-activities-products/product/left-column/left-three-rates.jsx